class CartNotification extends HTMLElement {
	constructor() {
		super()

		this.notification = document.getElementById('cart-notification')
		this.header = document.querySelector('sticky-header')
		this.onBodyClick = this.handleBodyClick.bind(this)

		if (this.notification) {
			this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close())
		}
		this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
			closeButton.addEventListener('click', this.close.bind(this))
		)
	}

	cartUpdateUnsubscriber = undefined

	connectedCallback() {
		this.setHeaderCartIconAccessibility()
		
		if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
			this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
				if (event.source === 'cart-notification' || event.source === 'cart-drawer') {
					return
				}
				if (event.cartData) {
					this.updateCartNotification(event.cartData, event.source)
				}
			})
		}
	}

	disconnectedCallback() {
		if (this.cartUpdateUnsubscriber) {
			this.cartUpdateUnsubscriber()
			this.cartUpdateUnsubscriber = undefined
		}
	}

	showSkeleton() {
		const cartProductContainer = document.getElementById('cart-notification-product')
		const cartTotalContainer = document.getElementById('cart-notification-total')
		
		if (cartProductContainer) {
			cartProductContainer.innerHTML = `
				<div class="ec-cart-notification-skeleton-item">
					<div class="ec-cart-notification-skeleton-image"></div>
					<div class="ec-cart-notification-skeleton-content">
						<div class="ec-cart-notification-skeleton-title"></div>
						<div class="ec-cart-notification-skeleton-price"></div>
					</div>
				</div>
			`
		}
		
		if (cartTotalContainer) {
			cartTotalContainer.innerHTML = `
				<div class="ec-cart-notification-total-wrapper">
					<span class="ec-cart-notification-total-label">TOTAL:</span>
					<span class="ec-cart-notification-skeleton-total"></span>
				</div>
			`
		}
	}

	async updateCartNotification(cartData, source) {
		if (!cartData || !this.notification) return

		let shouldOpen = false
		const wasEmpty = !cartData.item_count || cartData.item_count === 0

		try {
			const cartProductContainer = document.getElementById('cart-notification-product')
			const cartTotalContainer = document.getElementById('cart-notification-total')
			
			this.showSkeleton()

			if (cartData.sections) {
				if (cartData.sections['main-cart-items']) {
					const htmlText = cartData.sections['main-cart-items']
					const html = new DOMParser().parseFromString(htmlText, 'text/html')
					const cartItems = html.querySelectorAll('.cart-item')

					if (cartProductContainer) {
						if (cartItems.length > 0) {
							if (!cartData.sections || !cartData.sections['cart-notification-product']) {
								this.showSkeleton()
							}
							
							let productHtml
							if (cartData.sections['cart-notification-product']) {
								const productText = cartData.sections['cart-notification-product']
								productHtml = new DOMParser().parseFromString(productText, 'text/html')
							} else {
								const productResponse = await fetch(
									`${routes.cart_url}?section_id=cart-notification-product`
								)
								const productText = await productResponse.text()
								productHtml = new DOMParser().parseFromString(productText, 'text/html')
							}

							const groupedItems = new Map()

							const parsePrice = (priceText) => {
								if (!priceText) return 0
								const cleaned = priceText.replace(/[^\d,]/g, '').replace(',', '.')
								return parseFloat(cleaned) || 0
							}

							const formatPrice = (value) => {
								return new Intl.NumberFormat('pt-BR', {
									style: 'currency',
									currency: 'BRL'
								}).format(value)
							}

							cartItems.forEach((item) => {
								const variantId = item
									.querySelector('[data-quantity-variant-id]')
									?.getAttribute('data-quantity-variant-id')
								const quantityInput = item.querySelector('.quantity__input')
								const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1

								const priceWrapper = item.querySelector('.cart-item__price-wrapper')
								let finalLinePriceEl = null
								if (priceWrapper) {
									finalLinePriceEl = priceWrapper.querySelector('.price.price--end.ec-price-green')
									if (!finalLinePriceEl) {
										const allDdPrices = priceWrapper.querySelectorAll('dd.price.price--end')
										if (allDdPrices.length > 1) {
											finalLinePriceEl = allDdPrices[1]
										} else if (allDdPrices.length === 1 && !allDdPrices[0].querySelector('s')) {
											finalLinePriceEl = allDdPrices[0]
										}
									}
									if (!finalLinePriceEl) {
										finalLinePriceEl = priceWrapper.querySelector('.cart-item__final-price') ||
											priceWrapper.querySelector('span.price.price--end')
									}
								} else {
									finalLinePriceEl = item.querySelector('.price.price--end.ec-price-green')
									if (!finalLinePriceEl) {
										const allDdPrices = item.querySelectorAll('dd.price.price--end')
										if (allDdPrices.length > 1) {
											finalLinePriceEl = allDdPrices[1]
										} else if (allDdPrices.length === 1 && !allDdPrices[0].querySelector('s')) {
											finalLinePriceEl = allDdPrices[0]
										}
									}
									if (!finalLinePriceEl) {
										finalLinePriceEl = item.querySelector('.cart-item__final-price') ||
											item.querySelector('span.price.price--end')
									}
								}
								let originalLinePriceEl = null
								if (priceWrapper) {
									originalLinePriceEl = priceWrapper.querySelector('.cart-item__old-price.price--end') ||
										priceWrapper.querySelector('s.price.price--end')
									if (!originalLinePriceEl) {
										const firstDd = priceWrapper.querySelectorAll('dd.price.price--end')[0]
										if (firstDd && firstDd.querySelector('s')) {
											originalLinePriceEl = firstDd.querySelector('s')
										}
									}
								} else {
									originalLinePriceEl = item.querySelector('.cart-item__old-price.price--end') ||
										item.querySelector('s.price.price--end')
									if (!originalLinePriceEl) {
										const firstDd = item.querySelectorAll('dd.price.price--end')[0]
										if (firstDd && firstDd.querySelector('s')) {
											originalLinePriceEl = firstDd.querySelector('s')
										}
									}
								}
								const finalLinePriceText = finalLinePriceEl ? finalLinePriceEl.textContent.trim() : ''
								const originalLinePriceText = originalLinePriceEl
									? originalLinePriceEl.textContent.trim()
									: ''

								if (!groupedItems.has(variantId)) {
									const image = item.querySelector('.cart-item__image')
									const title = item.querySelector('.cart-item__name')
									const priceWrapper = item.querySelector('.cart-item__price-wrapper')

									const productItem = productHtml.querySelector(`[id*="cart-notification-product-"]`)
									const comparePriceEl = productItem
										? productItem.querySelector(
												'.cart-item__old-price, .ec-price-custom__original-value'
										  )
										: priceWrapper
										? priceWrapper.querySelector(
												'.cart-item__old-price, .ec-price-custom__original-value'
										  )
										: null
									const comparePriceUnit = comparePriceEl
										? parsePrice(comparePriceEl.textContent.trim())
										: 0

									groupedItems.set(variantId, {
										image: image ? image.outerHTML : '',
										title: title ? title.textContent : '',
										quantity: quantity,
										finalLinePrice: parsePrice(finalLinePriceText),
										originalLinePrice: parsePrice(originalLinePriceText),
										comparePriceUnit: comparePriceUnit,
										itemKey: item.id?.replace('CartItem-', '') || variantId,
										finalLinePriceText: finalLinePriceText
									})
								} else {
									const existing = groupedItems.get(variantId)
									existing.quantity += quantity
									existing.finalLinePrice += parsePrice(finalLinePriceText)
									existing.originalLinePrice += parsePrice(originalLinePriceText)
								}
							})

							let itemsHtml = ''
							groupedItems.forEach((itemData, variantId) => {
								let priceHtml = ''
								const finalPrice = formatPrice(itemData.finalLinePrice)
								const comparePriceTotal =
									itemData.comparePriceUnit > 0 ? itemData.comparePriceUnit * itemData.quantity : 0

								if (
									comparePriceTotal > 0 &&
									comparePriceTotal > itemData.finalLinePrice &&
									finalPrice
								) {
									const comparePriceFormatted = formatPrice(comparePriceTotal)
									priceHtml = `
                <div class="ec-cart-notification-prices">
                  <s class="ec-cart-notification-old-price">${comparePriceFormatted}</s>
                  <strong class="ec-cart-notification-final-price">${finalPrice}</strong>
                </div>
              `
								} else if (
									itemData.originalLinePrice > 0 &&
									itemData.originalLinePrice !== itemData.finalLinePrice &&
									finalPrice
								) {
									const originalPriceFormatted = formatPrice(itemData.originalLinePrice)
									priceHtml = `
                <div class="ec-cart-notification-prices">
                  <s class="ec-cart-notification-old-price">${originalPriceFormatted}</s>
                  <strong class="ec-cart-notification-final-price">${finalPrice}</strong>
                </div>
              `
								} else if (finalPrice) {
									priceHtml = `<div class="ec-cart-notification-prices"><strong class="ec-cart-notification-final-price">${finalPrice}</strong></div>`
								}

								itemsHtml += `
              <div id="cart-notification-product-${
									itemData.itemKey
								}" class="ec-cart-notification-item">
                ${
									itemData.image
										? `<div class="ec-cart-notification-image global-media-settings">${itemData.image}</div>`
										: ''
								}
                <div class="ec-cart-notification-content">
                  ${
										itemData.title
											? `<h3 class="ec-cart-notification-name">${itemData.title}</h3>`
											: ''
									}
                </div>
                ${priceHtml}
              </div>
            `
							})

							cartProductContainer.innerHTML = itemsHtml
							shouldOpen = true
						} else {
							cartProductContainer.innerHTML =
								'<p class="cart-notification-product__empty">Carrinho vazio</p>'
						}
					}
				}

				if (cartTotalContainer && shouldOpen) {
					let totalUpdated = false
					if (cartData.sections && cartData.sections['main-cart-footer']) {
						const footerText = cartData.sections['main-cart-footer']
						const footerHtml = new DOMParser().parseFromString(footerText, 'text/html')
						const section = footerHtml.querySelector('#shopify-section-main-cart-footer')
						const totalElement = section
							? section.querySelector('.totals__total-value')
							: footerHtml.querySelector('.totals__total-value')
						if (totalElement) {
							cartTotalContainer.innerHTML = `<div class="ec-cart-notification-total-wrapper"><span class="ec-cart-notification-total-label">TOTAL:</span> <span class="ec-cart-notification-total-value">${totalElement.textContent.trim()}</span></div>`
							totalUpdated = true
						}
					}
					
					if (!totalUpdated && cartData.total_price) {
						const totalPrice = this.formatMoney(cartData.total_price)
						cartTotalContainer.innerHTML = `<div class="ec-cart-notification-total-wrapper"><span class="ec-cart-notification-total-label">TOTAL:</span> <span class="ec-cart-notification-total-value">${totalPrice}</span></div>`
						totalUpdated = true
					}
					
					if (!totalUpdated) {
						this.updateCartTotalFromResponse()
					}
				}

				const cartIconBubble = document.getElementById('cart-icon-bubble')
				if (cartIconBubble && cartData.sections && cartData.sections['cart-icon-bubble']) {
					const cartIconText = cartData.sections['cart-icon-bubble']
					const cartIconHtml = new DOMParser().parseFromString(cartIconText, 'text/html')
					const sourceBubble = cartIconHtml.querySelector(
						'#shopify-section-cart-icon-bubble .cart-count-bubble'
					)
					if (sourceBubble) {
						const targetBubble = cartIconBubble.querySelector('.cart-count-bubble')
						if (targetBubble) {
							targetBubble.innerHTML = sourceBubble.innerHTML
						}
					}
				}

				const hasItems = cartData.item_count > 0 || shouldOpen
				const isAddAction = source === 'product-form' || source === 'ec-complementary-bundle' || source === 'ec-cart-upsell' || source === 'quick-add'
				const shouldOpenNotification = hasItems && isAddAction && !this.isClosing && !this.notification.classList.contains('active')
				
				if (shouldOpenNotification) {
					const heading = this.notification.querySelector('.cart-notification__heading')
					if (heading) {
						const iconCheckmark = heading.querySelector('svg') || heading.querySelector('.svg-wrapper')
						heading.innerHTML = ''
						if (iconCheckmark) heading.appendChild(iconCheckmark.cloneNode(true))
						heading.appendChild(document.createTextNode(' Carrinho'))
					}
					
					if (this.header) this.header.reveal()
					setTimeout(() => {
						if (!this.isClosing) {
							this.open(true)
						}
					}, 100)
				}
			} else if (cartData.item_count > 0) {
				const isAddAction = source === 'product-form' || source === 'ec-complementary-bundle' || source === 'ec-cart-upsell' || source === 'quick-add'
				const shouldOpenNotification = isAddAction && !this.isClosing && !this.notification.classList.contains('active')
				
				if (shouldOpenNotification) {
					const heading = this.notification.querySelector('.cart-notification__heading')
					if (heading) {
						const iconCheckmark = heading.querySelector('svg') || heading.querySelector('.svg-wrapper')
						heading.innerHTML = ''
						if (iconCheckmark) heading.appendChild(iconCheckmark.cloneNode(true))
						heading.appendChild(document.createTextNode(' Carrinho'))
					}
					
					if (this.header) this.header.reveal()
					setTimeout(() => {
						if (!this.isClosing) {
							this.open(true)
						}
					}, 100)
				}
			}
		} catch (error) {
			console.error('Erro ao atualizar cart notification:', error)
		}
	}

	setHeaderCartIconAccessibility() {
		const cartLink = document.querySelector('#cart-icon-bubble')
		if (!cartLink) {
			setTimeout(() => this.setHeaderCartIconAccessibility(), 100)
			return
		}

		if (cartLink.dataset.cartNotificationListener) return
		cartLink.dataset.cartNotificationListener = 'true'

		cartLink.setAttribute('role', 'button')
		cartLink.setAttribute('aria-haspopup', 'dialog')
		
		const clickHandler = (event) => {
			event.preventDefault()
			event.stopPropagation()
			this.openCartView(cartLink)
		}
		
		const keydownHandler = (event) => {
			if (event.code.toUpperCase() === 'SPACE') {
				event.preventDefault()
				event.stopPropagation()
				this.openCartView(cartLink)
			}
		}
		
		cartLink.addEventListener('click', clickHandler)
		cartLink.addEventListener('keydown', keydownHandler)
	}

	async openCartView(triggeredBy) {
		if (triggeredBy) this.setActiveElement(triggeredBy)

		if (this.notification.classList.contains('active') && !this.isClosing) {
			this.close()
			return
		}

		if (this.header) this.header.reveal()
		this.open(true)

		const cartProductContainer = document.getElementById('cart-notification-product')
		const cartTotalContainer = document.getElementById('cart-notification-total')
		
		this.showSkeleton()

		try {
			const [itemsResponse, productResponse, iconResponse, footerResponse] = await Promise.all([
				fetch(`${routes.cart_url}?section_id=main-cart-items`).then(r => r.text()),
				fetch(`${routes.cart_url}?section_id=cart-notification-product`).then(r => r.text()),
				fetch(`${routes.cart_url}?section_id=cart-icon-bubble`).then(r => r.text()),
				fetch(`${routes.cart_url}?section_id=main-cart-footer`).then(r => r.text())
			])

			const html = new DOMParser().parseFromString(itemsResponse, 'text/html')
			const productHtml = new DOMParser().parseFromString(productResponse, 'text/html')
			const iconHtml = new DOMParser().parseFromString(iconResponse, 'text/html')
			const footerHtml = new DOMParser().parseFromString(footerResponse, 'text/html')

			const cartItems = html.querySelectorAll('.cart-item')

			if (cartProductContainer) {
				if (cartItems.length > 0) {

					const groupedItems = new Map()

					const parsePrice = (priceText) => {
						if (!priceText) return 0
						const cleaned = priceText.replace(/[^\d,]/g, '').replace(',', '.')
						return parseFloat(cleaned) || 0
					}

					const formatPrice = (value) => {
						return new Intl.NumberFormat('pt-BR', {
							style: 'currency',
							currency: 'BRL'
						}).format(value)
					}

					cartItems.forEach((item) => {
						const variantId = item
							.querySelector('[data-quantity-variant-id]')
							?.getAttribute('data-quantity-variant-id')
						const quantityInput = item.querySelector('.quantity__input')
						const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1

						const priceWrapper = item.querySelector('.cart-item__price-wrapper')
						let finalLinePriceEl = null
						if (priceWrapper) {
							finalLinePriceEl = priceWrapper.querySelector('.price.price--end.ec-price-green')
							if (!finalLinePriceEl) {
								const allDdPrices = priceWrapper.querySelectorAll('dd.price.price--end')
								if (allDdPrices.length > 1) {
									finalLinePriceEl = allDdPrices[1]
								} else if (allDdPrices.length === 1 && !allDdPrices[0].querySelector('s')) {
									finalLinePriceEl = allDdPrices[0]
								}
							}
							if (!finalLinePriceEl) {
								finalLinePriceEl = priceWrapper.querySelector('.cart-item__final-price') ||
									priceWrapper.querySelector('span.price.price--end')
							}
						} else {
							finalLinePriceEl = item.querySelector('.price.price--end.ec-price-green')
							if (!finalLinePriceEl) {
								const allDdPrices = item.querySelectorAll('dd.price.price--end')
								if (allDdPrices.length > 1) {
									finalLinePriceEl = allDdPrices[1]
								} else if (allDdPrices.length === 1 && !allDdPrices[0].querySelector('s')) {
									finalLinePriceEl = allDdPrices[0]
								}
							}
							if (!finalLinePriceEl) {
								finalLinePriceEl = item.querySelector('.cart-item__final-price') ||
									item.querySelector('span.price.price--end')
							}
						}
						let originalLinePriceEl = null
						if (priceWrapper) {
							originalLinePriceEl = priceWrapper.querySelector('.cart-item__old-price.price--end') ||
								priceWrapper.querySelector('s.price.price--end')
							if (!originalLinePriceEl) {
								const firstDd = priceWrapper.querySelectorAll('dd.price.price--end')[0]
								if (firstDd && firstDd.querySelector('s')) {
									originalLinePriceEl = firstDd.querySelector('s')
								}
							}
						} else {
							originalLinePriceEl = item.querySelector('.cart-item__old-price.price--end') ||
								item.querySelector('s.price.price--end')
							if (!originalLinePriceEl) {
								const firstDd = item.querySelectorAll('dd.price.price--end')[0]
								if (firstDd && firstDd.querySelector('s')) {
									originalLinePriceEl = firstDd.querySelector('s')
								}
							}
						}
						const finalLinePriceText = finalLinePriceEl ? finalLinePriceEl.textContent.trim() : ''
						const originalLinePriceText = originalLinePriceEl
							? originalLinePriceEl.textContent.trim()
							: ''

						if (!groupedItems.has(variantId)) {
							const image = item.querySelector('.cart-item__image')
							const title = item.querySelector('.cart-item__name')
							const priceWrapper = item.querySelector('.cart-item__price-wrapper')

							const productItem = productHtml.querySelector(`[id*="cart-notification-product-"]`)
							const comparePriceEl = productItem
								? productItem.querySelector(
										'.cart-item__old-price, .ec-price-custom__original-value'
								  )
								: priceWrapper
								? priceWrapper.querySelector(
										'.cart-item__old-price, .ec-price-custom__original-value'
								  )
								: null
							const comparePriceUnit = comparePriceEl
								? parsePrice(comparePriceEl.textContent.trim())
								: 0

							groupedItems.set(variantId, {
								image: image ? image.outerHTML : '',
								title: title ? title.textContent : '',
								quantity: quantity,
								finalLinePrice: parsePrice(finalLinePriceText),
								originalLinePrice: parsePrice(originalLinePriceText),
								comparePriceUnit: comparePriceUnit,
								itemKey: item.id?.replace('CartItem-', '') || variantId,
								finalLinePriceText: finalLinePriceText
							})
						} else {
							const existing = groupedItems.get(variantId)
							existing.quantity += quantity
							existing.finalLinePrice += parsePrice(finalLinePriceText)
							existing.originalLinePrice += parsePrice(originalLinePriceText)
						}
					})

					let itemsHtml = ''
					groupedItems.forEach((itemData, variantId) => {
						let priceHtml = ''
						const finalPrice = formatPrice(itemData.finalLinePrice)
						const comparePriceTotal =
							itemData.comparePriceUnit > 0 ? itemData.comparePriceUnit * itemData.quantity : 0

						if (
							comparePriceTotal > 0 &&
							comparePriceTotal > itemData.finalLinePrice &&
							finalPrice
						) {
							const comparePriceFormatted = formatPrice(comparePriceTotal)
							priceHtml = `
                <div class="ec-cart-notification-prices">
                  <s class="ec-cart-notification-old-price">${comparePriceFormatted}</s>
                  <strong class="ec-cart-notification-final-price">${finalPrice}</strong>
                </div>
              `
						} else if (
							itemData.originalLinePrice > 0 &&
							itemData.originalLinePrice !== itemData.finalLinePrice &&
							finalPrice
						) {
							const originalPriceFormatted = formatPrice(itemData.originalLinePrice)
							priceHtml = `
                <div class="ec-cart-notification-prices">
                  <s class="ec-cart-notification-old-price">${originalPriceFormatted}</s>
                  <strong class="ec-cart-notification-final-price">${finalPrice}</strong>
                </div>
              `
						} else if (finalPrice) {
							priceHtml = `<div class="ec-cart-notification-prices"><strong class="ec-cart-notification-final-price">${finalPrice}</strong></div>`
						}

						itemsHtml += `
              <div id="cart-notification-product-${
								itemData.itemKey
							}" class="ec-cart-notification-item">
                ${
									itemData.image
										? `<div class="ec-cart-notification-image global-media-settings">${itemData.image}</div>`
										: ''
								}
                <div class="ec-cart-notification-content">
                  ${
										itemData.title
											? `<h3 class="ec-cart-notification-name">${itemData.title}</h3>`
											: ''
									}
                </div>
                ${priceHtml}
              </div>
            `
					})

					cartProductContainer.innerHTML = itemsHtml
				} else {
					cartProductContainer.innerHTML =
						'<p class="cart-notification-product__empty">Carrinho vazio</p>'
					if (cartTotalContainer) cartTotalContainer.innerHTML = ''
				}
			}

			const cartIconBubble = document.getElementById('cart-icon-bubble')
			const sourceBubble = iconHtml.querySelector(
				'#shopify-section-cart-icon-bubble .cart-count-bubble'
			)

			if (cartIconBubble && sourceBubble) {
				const targetBubble = cartIconBubble.querySelector('.cart-count-bubble')
				if (targetBubble) {
					targetBubble.innerHTML = sourceBubble.innerHTML
				}
			}

			const heading = this.notification.querySelector('.cart-notification__heading')
			if (heading) {
				const iconCheckmark = heading.querySelector('svg') || heading.querySelector('.svg-wrapper')
				heading.innerHTML = ''
				if (iconCheckmark) heading.appendChild(iconCheckmark.cloneNode(true))
				heading.appendChild(document.createTextNode(' Carrinho'))
			}

			if (cartTotalContainer) {
				const section = footerHtml.querySelector('#shopify-section-main-cart-footer')
				const totalElement = section
					? section.querySelector('.totals__total-value')
					: footerHtml.querySelector('.totals__total-value')
				if (totalElement) {
					cartTotalContainer.innerHTML = `<div class="ec-cart-notification-total-wrapper"><span class="ec-cart-notification-total-label">TOTAL:</span> <span class="ec-cart-notification-total-value">${totalElement.textContent.trim()}</span></div>`
				} else {
					this.updateCartTotalFromResponse()
				}
			}
		} catch (error) {
			console.error('Erro ao carregar carrinho:', error)
			window.location = routes.cart_url
		}
	}

	open(showOverlay = false) {
		if (this.isClosing) return
		
		this.showOverlay = showOverlay
		this.isClosing = false
		this.notification.classList.add('animate', 'active')

		const overlay = document.getElementById('cart-notification-overlay')
		if (showOverlay && overlay) {
			overlay.classList.add('ec-cart-notification-overlay--active')
			const closeOnOverlayClick = () => {
				this.close()
			}
			overlay.addEventListener('click', closeOnOverlayClick)
			this.overlayClickHandler = closeOnOverlayClick
		}

		this.notification.addEventListener(
			'transitionend',
			() => {
				if (this.notification.classList.contains('active')) {
					this.notification.focus()
					trapFocus(this.notification)
				}
			},
			{ once: true }
		)

		document.body.addEventListener('click', this.onBodyClick)
	}

	close() {
		if (!this.notification.classList.contains('active') || this.isClosing) return

		this.isClosing = true
		document.body.removeEventListener('click', this.onBodyClick)
		
		this.notification.classList.remove('active')
		const overlay = document.getElementById('cart-notification-overlay')
		if (overlay) {
			overlay.classList.remove('ec-cart-notification-overlay--active')
			if (this.overlayClickHandler) {
				overlay.removeEventListener('click', this.overlayClickHandler)
				this.overlayClickHandler = null
			}
		}

		let transitionEnded = false
		const handleTransitionEnd = (e) => {
			if (e.target !== this.notification) return
			if (transitionEnded) return
			transitionEnded = true

			if (!this.notification.classList.contains('active')) {
				removeTrapFocus(this.activeElement)
				this.isClosing = false
			}
		}

		this.notification.addEventListener('transitionend', handleTransitionEnd, { once: true })

		setTimeout(() => {
			if (this.isClosing && !transitionEnded) {
				transitionEnded = true
				removeTrapFocus(this.activeElement)
				this.isClosing = false
			}
		}, 500)
	}

	async renderContents(parsedState) {
		this.cartItemKey = parsedState.key

		try {
			const cartProductContainer = document.getElementById('cart-notification-product')
			const cartTotalContainer = document.getElementById('cart-notification-total')
			
			this.showSkeleton()

			let html, productHtml, cartItems

			if (parsedState.sections && parsedState.sections['main-cart-items']) {
				const htmlText = parsedState.sections['main-cart-items']
				html = new DOMParser().parseFromString(htmlText, 'text/html')
				cartItems = html.querySelectorAll('.cart-item')
			} else {
				this.showSkeleton()
				const response = await fetch(`${routes.cart_url}?section_id=main-cart-items`)
				const responseText = await response.text()
				html = new DOMParser().parseFromString(responseText, 'text/html')
				cartItems = html.querySelectorAll('.cart-item')
			}

			if (cartProductContainer) {
				if (cartItems.length > 0) {
					if (!parsedState.sections || !parsedState.sections['cart-notification-product']) {
						this.showSkeleton()
					}
					
					if (parsedState.sections && parsedState.sections['cart-notification-product']) {
						const productText = parsedState.sections['cart-notification-product']
						productHtml = new DOMParser().parseFromString(productText, 'text/html')
					} else {
						const productResponse = await fetch(
							`${routes.cart_url}?section_id=cart-notification-product`
						)
						const productText = await productResponse.text()
						productHtml = new DOMParser().parseFromString(productText, 'text/html')
					}

					const groupedItems = new Map()

					const parsePrice = (priceText) => {
						if (!priceText) return 0
						const cleaned = priceText.replace(/[^\d,]/g, '').replace(',', '.')
						return parseFloat(cleaned) || 0
					}

					const formatPrice = (value) => {
						return new Intl.NumberFormat('pt-BR', {
							style: 'currency',
							currency: 'BRL'
						}).format(value)
					}

					cartItems.forEach((item) => {
						const variantId = item
							.querySelector('[data-quantity-variant-id]')
							?.getAttribute('data-quantity-variant-id')
						const quantityInput = item.querySelector('.quantity__input')
						const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1

						const priceWrapper = item.querySelector('.cart-item__price-wrapper')
						let finalLinePriceEl = null
						if (priceWrapper) {
							finalLinePriceEl = priceWrapper.querySelector('.price.price--end.ec-price-green')
							if (!finalLinePriceEl) {
								const allDdPrices = priceWrapper.querySelectorAll('dd.price.price--end')
								if (allDdPrices.length > 1) {
									finalLinePriceEl = allDdPrices[1]
								} else if (allDdPrices.length === 1 && !allDdPrices[0].querySelector('s')) {
									finalLinePriceEl = allDdPrices[0]
								}
							}
							if (!finalLinePriceEl) {
								finalLinePriceEl = priceWrapper.querySelector('.cart-item__final-price') ||
									priceWrapper.querySelector('span.price.price--end')
							}
						} else {
							finalLinePriceEl = item.querySelector('.price.price--end.ec-price-green')
							if (!finalLinePriceEl) {
								const allDdPrices = item.querySelectorAll('dd.price.price--end')
								if (allDdPrices.length > 1) {
									finalLinePriceEl = allDdPrices[1]
								} else if (allDdPrices.length === 1 && !allDdPrices[0].querySelector('s')) {
									finalLinePriceEl = allDdPrices[0]
								}
							}
							if (!finalLinePriceEl) {
								finalLinePriceEl = item.querySelector('.cart-item__final-price') ||
									item.querySelector('span.price.price--end')
							}
						}
						let originalLinePriceEl = null
						if (priceWrapper) {
							originalLinePriceEl = priceWrapper.querySelector('.cart-item__old-price.price--end') ||
								priceWrapper.querySelector('s.price.price--end')
							if (!originalLinePriceEl) {
								const firstDd = priceWrapper.querySelectorAll('dd.price.price--end')[0]
								if (firstDd && firstDd.querySelector('s')) {
									originalLinePriceEl = firstDd.querySelector('s')
								}
							}
						} else {
							originalLinePriceEl = item.querySelector('.cart-item__old-price.price--end') ||
								item.querySelector('s.price.price--end')
							if (!originalLinePriceEl) {
								const firstDd = item.querySelectorAll('dd.price.price--end')[0]
								if (firstDd && firstDd.querySelector('s')) {
									originalLinePriceEl = firstDd.querySelector('s')
								}
							}
						}
						const finalLinePriceText = finalLinePriceEl ? finalLinePriceEl.textContent.trim() : ''
						const originalLinePriceText = originalLinePriceEl
							? originalLinePriceEl.textContent.trim()
							: ''

						if (!groupedItems.has(variantId)) {
							const image = item.querySelector('.cart-item__image')
							const title = item.querySelector('.cart-item__name')
							const priceWrapper = item.querySelector('.cart-item__price-wrapper')

							const productItem = productHtml.querySelector(`[id*="cart-notification-product-"]`)
							const comparePriceEl = productItem
								? productItem.querySelector(
										'.cart-item__old-price, .ec-price-custom__original-value'
								  )
								: priceWrapper
								? priceWrapper.querySelector(
										'.cart-item__old-price, .ec-price-custom__original-value'
								  )
								: null
							const comparePriceUnit = comparePriceEl
								? parsePrice(comparePriceEl.textContent.trim())
								: 0

							groupedItems.set(variantId, {
								image: image ? image.outerHTML : '',
								title: title ? title.textContent : '',
								quantity: quantity,
								finalLinePrice: parsePrice(finalLinePriceText),
								originalLinePrice: parsePrice(originalLinePriceText),
								comparePriceUnit: comparePriceUnit,
								itemKey: item.id?.replace('CartItem-', '') || variantId,
								finalLinePriceText: finalLinePriceText
							})
						} else {
							const existing = groupedItems.get(variantId)
							existing.quantity += quantity
							existing.finalLinePrice += parsePrice(finalLinePriceText)
							existing.originalLinePrice += parsePrice(originalLinePriceText)
						}
					})

					let itemsHtml = ''
					groupedItems.forEach((itemData, variantId) => {
						let priceHtml = ''
						const finalPrice = formatPrice(itemData.finalLinePrice)
						const comparePriceTotal =
							itemData.comparePriceUnit > 0 ? itemData.comparePriceUnit * itemData.quantity : 0

						if (
							comparePriceTotal > 0 &&
							comparePriceTotal > itemData.finalLinePrice &&
							finalPrice
						) {
							const comparePriceFormatted = formatPrice(comparePriceTotal)
							priceHtml = `
                <div class="ec-cart-notification-prices">
                  <s class="ec-cart-notification-old-price">${comparePriceFormatted}</s>
                  <strong class="ec-cart-notification-final-price">${finalPrice}</strong>
                </div>
              `
						} else if (
							itemData.originalLinePrice > 0 &&
							itemData.originalLinePrice !== itemData.finalLinePrice &&
							finalPrice
						) {
							const originalPriceFormatted = formatPrice(itemData.originalLinePrice)
							priceHtml = `
                <div class="ec-cart-notification-prices">
                  <s class="ec-cart-notification-old-price">${originalPriceFormatted}</s>
                  <strong class="ec-cart-notification-final-price">${finalPrice}</strong>
                </div>
              `
						} else if (finalPrice) {
							priceHtml = `<div class="ec-cart-notification-prices"><strong class="ec-cart-notification-final-price">${finalPrice}</strong></div>`
						}

						itemsHtml += `
              <div id="cart-notification-product-${
								itemData.itemKey
							}" class="ec-cart-notification-item">
                ${
									itemData.image
										? `<div class="ec-cart-notification-image global-media-settings">${itemData.image}</div>`
										: ''
								}
                <div class="ec-cart-notification-content">
                  ${
										itemData.title
											? `<h3 class="ec-cart-notification-name">${itemData.title}</h3>`
											: ''
									}
                </div>
                ${priceHtml}
              </div>
            `
					})

					cartProductContainer.innerHTML = itemsHtml

					if (cartTotalContainer) {
						let totalUpdated = false
						if (parsedState.sections && parsedState.sections['main-cart-footer']) {
							const footerText = parsedState.sections['main-cart-footer']
							const footerHtml = new DOMParser().parseFromString(footerText, 'text/html')
							const section = footerHtml.querySelector('#shopify-section-main-cart-footer')
							const totalElement = section
								? section.querySelector('.totals__total-value')
								: footerHtml.querySelector('.totals__total-value')
							if (totalElement) {
								cartTotalContainer.innerHTML = `<div class="ec-cart-notification-total-wrapper"><span class="ec-cart-notification-total-label">TOTAL:</span> <span class="ec-cart-notification-total-value">${totalElement.textContent.trim()}</span></div>`
								totalUpdated = true
							}
						}
						
						if (!totalUpdated) {
							const cartFooter = html.querySelector('.cart__blocks') || html.querySelector('.totals')
							if (cartFooter) {
								const totalElement =
									cartFooter.querySelector('.totals__total-value') ||
									html.querySelector('[data-cart-total]')
								if (totalElement) {
									cartTotalContainer.innerHTML = `<div class="ec-cart-notification-total-wrapper"><span class="ec-cart-notification-total-label">TOTAL:</span> <span class="ec-cart-notification-total-value">${totalElement.textContent.trim()}</span></div>`
									totalUpdated = true
								}
							}
						}
						
						if (!totalUpdated && parsedState && parsedState.total_price) {
							const totalPrice = this.formatMoney(parsedState.total_price)
							cartTotalContainer.innerHTML = `<div class="ec-cart-notification-total-wrapper"><span class="ec-cart-notification-total-label">TOTAL:</span> <span class="ec-cart-notification-total-value">${totalPrice}</span></div>`
							totalUpdated = true
						}
						
						if (!totalUpdated) {
							await this.updateCartTotalFromResponse()
						}
					}
				} else {
					cartProductContainer.innerHTML =
						'<p class="cart-notification-product__empty">Carrinho vazio</p>'
					if (cartTotalContainer) cartTotalContainer.innerHTML = ''
				}
			} else if (cartTotalContainer && (!parsedState.sections || !parsedState.sections['main-cart-footer'])) {
				await this.updateCartTotalFromResponse()
			}

			if (parsedState.sections) {
				this.getSectionsToRender().forEach((section) => {
					const sectionId = section.section || section.id
					if (
						sectionId !== 'cart-notification-product' &&
						sectionId !== 'cart-notification-total' &&
						sectionId !== 'main-cart-items' &&
						sectionId !== 'main-cart-footer' &&
						parsedState.sections[sectionId]
					) {
						const sectionHtml = this.getSectionInnerHTML(
							parsedState.sections[sectionId],
							section.selector || '.shopify-section'
						)
						const element = document.getElementById(section.id)
						if (element) {
							element.innerHTML = sectionHtml
						}
					}
				})
			}

			if (this.header) this.header.reveal()
			if (!this.isClosing) {
				this.open(false)
			}
		} catch (error) {
			console.error('Erro ao renderizar conteúdo do carrinho:', error)
			this.updateCartTotal(parsedState)
			if (this.header) this.header.reveal()
			if (!this.isClosing) {
				this.open(false)
			}
		}
	}

	async updateCartTotalFromResponse() {
		const cartTotalContainer = document.getElementById('cart-notification-total')
		if (!cartTotalContainer) return

		try {
			const footerResponse = await fetch(`${routes.cart_url}?section_id=main-cart-footer`)
			const footerText = await footerResponse.text()
			const footerHtml = new DOMParser().parseFromString(footerText, 'text/html')
			const section = footerHtml.querySelector('#shopify-section-main-cart-footer')
			const totalElement = section
				? section.querySelector('.totals__total-value')
				: footerHtml.querySelector('.totals__total-value')

			if (totalElement) {
				cartTotalContainer.innerHTML = `<div class="ec-cart-notification-total-wrapper"><span class="ec-cart-notification-total-label">TOTAL:</span> <span class="ec-cart-notification-total-value">${totalElement.textContent.trim()}</span></div>`
			} else {
				const cartResponse = await fetch(`${routes.cart_url}.js`)
				const cartData = await cartResponse.json()
				if (cartData && cartData.total_price) {
					const totalPrice = this.formatMoney(cartData.total_price)
					cartTotalContainer.innerHTML = `<div class="ec-cart-notification-total-wrapper"><span class="ec-cart-notification-total-label">TOTAL:</span> <span class="ec-cart-notification-total-value">${totalPrice}</span></div>`
				}
			}
		} catch (error) {
			console.error('Erro ao buscar total do carrinho:', error)
		}
	}

	async updateCartTotal(parsedState) {
		const cartTotalContainer = document.getElementById('cart-notification-total')
		if (!cartTotalContainer) return

		try {
			const response = await fetch(`${routes.cart_url}?section_id=main-cart-footer`)
			const responseText = await response.text()
			const html = new DOMParser().parseFromString(responseText, 'text/html')
			const section = html.querySelector('#shopify-section-main-cart-footer')
			const totalElement = section
				? section.querySelector('.totals__total-value')
				: html.querySelector('.totals__total-value')

			if (totalElement) {
				cartTotalContainer.innerHTML = `<div class="ec-cart-notification-total-wrapper"><span class="ec-cart-notification-total-label">TOTAL:</span> <span class="ec-cart-notification-total-value">${totalElement.textContent.trim()}</span></div>`
			} else if (parsedState && parsedState.total_price) {
				const totalPrice = this.formatMoney(parsedState.total_price)
				cartTotalContainer.innerHTML = `<div class="ec-cart-notification-total-wrapper"><span class="ec-cart-notification-total-label">TOTAL:</span> <span class="ec-cart-notification-total-value">${totalPrice}</span></div>`
			} else {
				const cartResponse = await fetch(`${routes.cart_url}.js`)
				const cartData = await cartResponse.json()
				if (cartData && cartData.total_price) {
					const totalPrice = this.formatMoney(cartData.total_price)
					cartTotalContainer.innerHTML = `<div class="ec-cart-notification-total-wrapper"><span class="ec-cart-notification-total-label">TOTAL:</span> <span class="ec-cart-notification-total-value">${totalPrice}</span></div>`
				}
			}
		} catch (error) {
			console.error('Erro ao buscar total do carrinho:', error)
		}
	}

	formatMoney(cents) {
		return new Intl.NumberFormat(document.documentElement.lang || 'pt-BR', {
			style: 'currency',
			currency: 'BRL'
		}).format(cents / 100)
	}

	getSectionsToRender() {
		const sections = [
			{
				id: 'main-cart-items',
				section: 'main-cart-items'
			},
			{
				id: 'cart-notification-product',
				section: 'cart-notification-product'
			},
			{
				id: 'main-cart-footer',
				section: 'main-cart-footer'
			},
			{
				id: 'cart-icon-bubble',
				section: 'cart-icon-bubble'
			}
		]
		
		if (this.cartItemKey) {
			sections[1].selector = `[id="cart-notification-product-${this.cartItemKey}"]`
		}
		
		return sections
	}

	getSectionInnerHTML(html, selector = '.shopify-section') {
		return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML
	}

	handleBodyClick(evt) {
		if (this.isClosing) return
		
		const target = evt.target
		const isInsideNotification = this.notification.contains(target) || target === this.notification
		const isInsideOverlay = target.id === 'cart-notification-overlay'
		const isCartNotificationButton = target.closest('#cart-notification-button')
		
		if (isInsideNotification || isInsideOverlay || isCartNotificationButton) {
			return
		}
		
		const disclosure = target.closest('details-disclosure, header-menu')
		this.activeElement = disclosure ? disclosure.querySelector('summary') : null
		this.close()
	}

	setActiveElement(element) {
		this.activeElement = element
	}
}

customElements.define('cart-notification', CartNotification);
